import DispensaryCategoryPage from 'src/dispensary/category';
import { MainDispensaryLayout } from 'src/components/layouts/main-dispensary-layout';
import { withLayout } from 'src/components/layouts/with-layout';

export default withLayout(DispensaryCategoryPage, MainDispensaryLayout);
